import Vue from "vue";
import Router from "vue-router";
import _ from "lodash";
const Listagem = global.reqClass.requirecmpmix("@/admin/listagem/crud");
const Login = global.reqClass.requirecmpmix("@/admin/login");
const Cockpit = global.reqClass.requirecmpmix("@/admin/cockpit");
const MasterAdmin = global.reqClass.requirecmpmix("@/masters/global/admin");
const MasterMaster = global.reqClass.requirecmpmix("@/masters/global/master");
const AdminPage = global.reqClass.requirecmpmix("@/admin/page");

const components = {};
const pagesroutes = [];
if (global.reqClass.pageroutes != null) {
  global.reqClass.pageroutes.forEach(path => {
    let path1 = path.substr(1);
    components[path1] = global.reqClass.requirecmpmix("@/page/" + path1);

    if (path1 == "index") {
      pagesroutes.push({
        path: "" + "",
        name: "__" + path1.replace("/", "-"),
        component: components[path1]
      });
    }
    pagesroutes.push({
      path: path1 + "/:p1?/:p2?/:p3?/:p4?/:p5?",
      name: path1.replace("/", "-"),
      component: components[path1]
    });

    //console.log(pagesroutes)
  });
}

const routes = [
  {
    path: "/",
    component: MasterMaster,
    children: pagesroutes
  },
  {
    path: "/admin",
    component: MasterAdmin,
    children: [
      {
        path: "",
        name: "admin-index",
        component: Cockpit
      },
      {
        path: "login",
        name: "admin-login",
        component: Login
      },

      {
        path: "cockpit",
        name: "admin-cockpit",
        component: Cockpit
      },
      {
        path: "page",
        component: AdminPage,
        children: pagesroutes.map(v => {
          v = _.clone(v);
          v.name = "adminpage-" + v.name;
          return v;
        })
      },

      {
        path: "metadmin/modulos",
        name: "admin-metadmin-modulos",
        component: global.reqClass.requirecmpmix("@/admin/metadmin/modulos")
      },

      {
        path: "app/:module/:sid/:action",
        component: Listagem
      },
      {
        path: "app/:module/:sid/:action/:id",
        component: Listagem
      },
      {
        path: "app/:module",
        component: Listagem
      }
    ]
  }
];

Vue.use(Router);

export default new Router({
  routes
});
